import { gql } from '@apollo/client'

import { DeclarationFunctionFragment } from '../../../fragments'
import { getQueryService } from '../../../../helpers/GraphqlHelpers'

export const functions = getQueryService({
  query: gql`
    query functions($first: Int!) {
      functions(first: $first) {
        data {
          ...DeclarationFunctionFragment
        }
        paginatorInfo {
          total
          count
        }
      }
    }
    ${DeclarationFunctionFragment}
  `,
  transformer: (response) => {
    return response
  },
})
